import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // This loads your Tailwind styles
import App from './App'; // This loads your new modular App component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);